import ICustomForm from "../../ICustomForm";
import Battery from "../Battery";
import m, {Vnode} from "mithril";

/**
 * Hub
 *
 * Transform form with single radio list to hub
 */
export default class BatteryYesNoDK extends Battery implements ICustomForm {

    private static readonly ICONS = ['check-simple.success', 'close.danger', 'help-circle-outline.text-gray'];

    viewOptions(): Vnode {
        const form = this.settings.form;
        const questionary = form.questionary;
        const options = [];
        let i = 0;
        for (const answer of this.questionCard.answers) {
            options.push(m('label'+ (answer.radio.isChecked()?'.selected':''), {
                onclick: () => this.onAnswerSelect(answer),
            }, [
                m('input', {
                    type: 'radio',
                    value: answer.radio.getValue(),
                    name: 'batteryAnswer',
                    checked: answer.radio.isChecked(),
                }),
                m('span', {}, [
                    m('i.icon.icon-'+BatteryYesNoDK.ICONS[i]),
                    m.trust(questionary.renderText(answer.label)) 
                ])
            ]));
            i++;
        }

        const isAnswered = this.questionCard.isAnswered() ? "answered" : "not-answered";
        return m('.options.'+isAnswered, {}, options);
    }


}
